'use client';

import Icon from '@/components/ui/AppIcon';

interface TrustSignal {
  id: string;
  icon: string;
  label: string;
  description: string;
}

interface TrustSignalBarProps {
  variant?: 'compact' | 'detailed';
  showIcons?: boolean;
}

const TrustSignalBar = ({ 
  variant = 'compact',
  showIcons = true 
}: TrustSignalBarProps) => {
  const trustSignals: TrustSignal[] = [
    {
      id: 'hipaa',
      icon: 'ShieldCheckIcon',
      label: 'HIPAA Compliant',
      description: 'Your health data is protected with industry-leading security standards'
    },
    {
      id: 'licensed',
      icon: 'AcademicCapIcon',
      label: 'Licensed Physicians',
      description: 'All consultations with board-certified healthcare professionals'
    },
    {
      id: 'secure',
      icon: 'LockClosedIcon',
      label: 'Secure Platform',
      description: 'End-to-end encrypted communications for your privacy'
    },
    {
      id: 'available',
      icon: 'ClockIcon',
      label: '24/7 Available',
      description: 'Access healthcare support whenever you need it'
    }
  ];

  if (variant === 'detailed') {
    return (
      <div className="bg-card border border-border rounded-lg p-8">
        <h3 className="font-heading font-semibold text-xl text-foreground mb-6 text-center">
          Your Health, Our Priority
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {trustSignals.map((signal) => (
            <div 
              key={signal.id}
              className="flex flex-col items-center text-center"
            >
              <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mb-4">
                <Icon 
                  name={signal.icon as any} 
                  size={32} 
                  className="text-primary"
                />
              </div>
              <h4 className="font-heading font-semibold text-foreground mb-2">
                {signal.label}
              </h4>
              <p className="text-sm text-muted-foreground">
                {signal.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="bg-muted/50 border-y border-border py-4">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap items-center justify-center gap-6 lg:gap-12">
          {trustSignals.map((signal, index) => (
            <div 
              key={signal.id}
              className="flex items-center gap-2 text-sm"
            >
              {showIcons && (
                <Icon 
                  name={signal.icon as any} 
                  size={20} 
                  className="text-primary flex-shrink-0"
                />
              )}
              <span className="font-medium text-foreground whitespace-nowrap">
                {signal.label}
              </span>
              {index < trustSignals.length - 1 && (
                <span className="hidden lg:block text-border ml-6">|</span>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TrustSignalBar;